import React, { FunctionComponent } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import { GatsbyImage, GatsbyImageProps } from 'gatsby-plugin-image';

export type ImageProps = GatsbyImageProps;

const useStyles = () => {
  const { breakpoint } = useTheme();
  return {
    root: {
      display: 'none',
      [breakpoint.up('xl')]: {
        display: 'flex',
      },
    },
  };
};

const Image: FunctionComponent<ImageProps> = (props) => {
  const { image, ...other } = props;
  const classes = useStyles();

  return (
    <Flex flex="1 0 45%" justifyContent="center" css={classes.root}>
      <Flex width="100%" maxWidth={image.width} margin={[0, 8]}>
        <GatsbyImage loading="lazy" css={{ width: '100%' }} image={image} {...other} />
      </Flex>
    </Flex>
  );
};

export default Image;
